/**
 * Configurazione informazioni di contatto assistenza
 */
export const contactConfig = {
  assistance: {
    email: 'assistenza@novaerasrls.it',
    phone: '+39 379 1822389',
  },
} as const;
